// removed by extract-text-webpack-plugin
module.exports = {"dropShopOpeningHours":"_39iHh3m3tHoRWaIexuUa_0","annualClose":"_17ZgQRGCZEGPkmJ1qx4ls_0"};


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"autoprefixer":false,"localIdentName":"[hash:base64]_0","importLoaders":1,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ab9d2f00","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/drop-shop/CbrDropShopOpeningHours.vue
// module id = 141
// module chunks = 0